<app-header></app-header>
<app-sidebar
  ativo="Notificações"
></app-sidebar>
<div class="content-wrapper">
  <section class="content">
    <app-breadcrumb
      Titulo="Notificações"
      Pagina="Notificações"
    ></app-breadcrumb>
    <div class="row">

      <div class="card">
        <div class="card-header">
          <!-- Search -->
          <div class="row align-items-center">
            <div class="col-sm-12">
              <div class="text-sm-end">
                <button class="btn btn-warning" style="margin-right: 20px" (click)="limparNotificacoes()">
                  <i class="fa fa-trash me-2"></i>Limpar todas
                </button>
                <button class="btn btn-primary" (click)="carregarNotificacoes()">
                  <i class="fa fa-refresh me-2"></i>Atualizar
                </button>
              </div>
            </div>
          </div>
          <!-- /Search -->
        </div>

        <div class="card-body">
          <!-- Filter -->
          <div class="d-flex align-items-center justify-content-between flex-wrap mb-4 row-gap-2">
            <div class="d-flex align-items-center flex-wrap row-gap-2">
              <div class="d-flex align-items-center flex-wrap row-gap-2">
                <h4 class="mb-0 me-3">Todas as Notificações</h4>
              </div>
            </div>
          </div>
          <!-- /Filter -->

          <!-- Notification List -->
          <div class="table-responsive custom-table">
            <table class="table" id="notification-list">
              <thead class="thead-light">
              <tr>
                <th>Título</th>
                <th>Conteúdo</th>
                <th>Data</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngIf="loading">
                <td colspan="5" class="text-center">
                  Carregando...
                </td>
              </tr>
              <tr *ngIf="!loading && filteredNotificacoes.length === 0">
                <td colspan="5" class="text-center">
                  Nenhuma notificação encontrada
                </td>
              </tr>
              <tr *ngFor="let notificacao of filteredNotificacoes">
                <td>{{ notificacao.titulo }}</td>
                <td>{{ notificacao.texto }}</td>
                <td>{{ notificacao.datacadastro | date:'dd/MM/yyyy HH:mm' }}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <!-- /Notification List -->

          <!-- Pagination -->
          <div class="row align-items-center mt-3">
            <div class="col-md-12">
            </div>
          </div>
          <!-- /Pagination -->
        </div>
      </div>
    </div>
  </section>
</div>
